import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@rabobank/rds-components/dist/loader';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

defineCustomElements(window, {
  resourcesUrl: 'rds/',
});

async function prepareApp() {
  if (environment.environmentName === 'local') {
    const { worker } = await import('./mocks/browser');
    return worker.start({ onUnhandledRequest: 'bypass' });
  }

  return Promise.resolve();
}

prepareApp().then(() => {
  bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err),
  );
});
